module.exports = __webpack_public_path__ + "static/media/favicon.91fec2a3.ico";